export default [
   '0.5rem',
   '0.75rem',
   '0.875rem',
   '1rem',
   '1.25rem',
   '1.5rem',
   '2rem',
   '2.5rem',
   '4rem',
   '5rem',
];
